export { DetailWrapper } from './DetailWrapper';